module.exports = __webpack_public_path__ + "static/media/virus (2).1acfe356.png";